<div class="contents">
  @if (!isIframe) {
    <router-outlet></router-outlet>
  }
</div>
